import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { message } from 'antd';
import { useSelector } from 'react-redux';

import NotFound from 'pages/NotFound';
import { getSyncStoreUser } from 'globals/selectors';
import withSyncStoreRouterSpecialisation from 'globals/withSyncStoreRouterSpecialisation';

import GlobalText from '../texts/Global';

function createProtectedComponentWithSpecialisationCheck(
  CustomComponent,
  authorizedUsers,
) {
  function ProtectedComponent(props) {
    const { specialisation } = props;
    const user = useSelector(getSyncStoreUser);
    const isAuthorized =
      user !== undefined &&
      user !== null &&
      authorizedUsers.includes(user.role);

    useEffect(() => {
      if (specialisation && !isAuthorized) {
        message.error(GlobalText.unauthorizedError);
      }
    }, [specialisation, isAuthorized]);

    if (!specialisation) {
      return <NotFound />;
    }
    if (isAuthorized) {
      return <CustomComponent {...props} />;
    }
    if (authorizedUsers.includes('student')) {
      return <Redirect to={`/${specialisation}/users/login`} />;
    }
    return <Redirect to={`/${specialisation}/users/privilegedlogin`} />;
  }
  ProtectedComponent.propTypes = {
    specialisation: PropTypes.string.isRequired,
  };
  return withSyncStoreRouterSpecialisation(ProtectedComponent, ['user']);
}
export default createProtectedComponentWithSpecialisationCheck;
